import { Component, inject, Inject } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TrailPropertiesService } from '../../service/trail-properties.service';
import { BoolDto } from '../../../../common/dto/bool-dto';
import { TrailDpSensor } from '../../dto/trail-dp-sensor';

@Component({
  selector: 'dpi-trail-dp-sensor-detail',
  imports: [MatInputModule, MatFormFieldModule, MatSelectModule, FormsModule, MatButtonModule, MatIconModule, MatTooltipModule, MatDialogModule],
  templateUrl: './trail-dp-sensor-detail.component.html',
  styleUrl: './trail-dp-sensor-detail.component.scss'
})
export class TrailDpSensorDetailComponent {
  readonly dialogRef = inject(MatDialogRef<TrailDpSensorDetailComponent>);
  trailDpSensor: TrailDpSensor;
  isToUpdate: boolean;
  isToDelete: boolean;
  
  checkedStates: BoolDto[];
  selectedState: BoolDto;

  constructor(@Inject(MAT_DIALOG_DATA) public data: TrailDpSensor, private trailPropertiesService: TrailPropertiesService) {
    this.trailDpSensor = data;
    this.isToUpdate = false;
    this.isToDelete = false;

    this.checkedStates = this.trailPropertiesService.getAllTrialBinaryStates();
    this.selectedState = this.trailPropertiesService.getTrialSetupBinaryState(this.checkedStates, data.records_checked);
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onUpdateClick() {
    this.trailDpSensor.records_checked = this.selectedState.state;
    this.isToUpdate = true;
  }

  onDeleteClick() {
    this.isToDelete = true;
    this.dialogRef.close();
  }

}
